import update from 'immutability-helper'
import qs from 'qs'

const handleClassmatesDirectoryQS = (state) => {
  console.log('classmates qs', state)
  const queryString = {}

  if (state.city !== '') {
    queryString.city = state.city
  }

  if (state.state !== '') {
    queryString.state = state.state
  }

  if (state.name !== '') {
    queryString.name = state.name
  }

  if (state.company !== '') {
    queryString.company = state.company
  }

  return queryString
}

const filterClassmates = ({
  classmates,
  city,
  company,
  name,
  state
}) => {
  return classmates.filter((o) => {
    if (name !== '') {
      if (o.fullName.toLowerCase().match(
        RegExp(`^(?=.*${name.toLowerCase().trim().split(' ').join('.*')}).*$`, 'im')
      ) === null) {
        return false
      }
    }

    if (city !== '') {
      if (o.city.toLowerCase().match(
        RegExp(`^(?=.*${city.toLowerCase().trim().split(' ').join('.*')}).*$`, 'im')
      ) === null) {
        return false
      }
    }

    if (company !== '' && o.company !== company) {
      return false
    }

    if (state !== '' && o.state.toLowerCase() !== state.toLowerCase()) {
      return false
    }

    return !(state !== '' && o.state !== state)
  })
}

const filterNewClassmates = (newState, setState) => {
  const newClassmates = filterClassmates(newState)

  setState(update(newState, {
    items: { $set: newClassmates },
    lastPage: { $set: Math.ceil(newClassmates.length / 60) },
    page: { $set: 1 }
  }))

  const queryString = handleClassmatesDirectoryQS(newState)
  window.history.pushState('', 'Classmates', '/classmates/')
  window.location.hash = qs.stringify(queryString)
}

export {
  filterClassmates,
  filterNewClassmates,
  handleClassmatesDirectoryQS
}
